
import React from 'react';
import Grid from '@mui/joy/Grid';
import Divider from '@mui/material/Divider';



//////////////////// Components
import Statistics from '../../Components/StatisticsWebsite/Statistics';
import StatisticsNumbersFieldsComponents from '../../Components/StatisticsWebsite/StatisticsNumbersFields';


export default function StatisticsNumber () {
    return(
        <>
            <h2>سومها بالارقام</h2>
            <Grid
                container
                rowSpacing={3}
                direction="column"
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                sx={{ width: '100%' }}
            >
                <Grid xs={6}>
                    <StatisticsNumbersFieldsComponents/>
                </Grid>
            </Grid>

            <Divider sx={{margin:'50px 0'}}/>

            <h2>الإحصائيات</h2>
            <Grid
                container
                rowSpacing={3}
                direction="column"
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                sx={{ width: '100%' }}
            >
                <Grid xs={12}>
                   <Statistics/>
                </Grid>
            </Grid>
        </>
    )
}